// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import { BannerFieldsFragmentDoc } from './banner.generated';
import { BookingForListFieldsFragmentDoc } from './bookings.generated';
import { MetricFieldsFragmentDoc } from './metrics.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DashboardHomeFeatureFragment = { __typename?: 'Feature', id: string, title: string, description: string, url: string, badge?: Types.FeatureBadgeType | null, feature_key: Types.FeatureIconKey };

export type DashboardHomeTipFragment = { __typename?: 'Tip', id: string, title: string, message: string, action_url?: string | null, action_label?: string | null };

export type DashboardHomeAlertFragment = { __typename?: 'Alert', id: string, title: string, message: string, action_url?: string | null, action_label?: string | null, severity: Types.AlertSeverity };

export type DashboardHomeQuickActionFragment = { __typename?: 'QuickAccessAction', id: string, label: string, url: string, badge?: Types.FeatureBadgeType | null, feature_key: Types.FeatureIconKey };

export type DashboardHomeBannerSectionFieldsFragment = { __typename?: 'BannerSection', id: string, title: string, order: number, banners: Array<{ __typename?: 'Banner', id: string, type: Types.BannerType, content_default: { __typename?: 'BannerContent', title_lines: Array<string>, body?: string | null, color_mode?: Types.ColorMode | null, image?: { __typename?: 'Media', url: string } | null, ctas: Array<{ __typename?: 'CallToAction', url_default: string, url_ios?: string | null, url_android?: string | null, label: string, image?: { __typename?: 'Media', url: string } | null }> }, content_mobile?: { __typename?: 'BannerContent', title_lines: Array<string>, body?: string | null, color_mode?: Types.ColorMode | null, image?: { __typename?: 'Media', url: string } | null, ctas: Array<{ __typename?: 'CallToAction', url_default: string, url_ios?: string | null, url_android?: string | null, label: string, image?: { __typename?: 'Media', url: string } | null }> } | null }> };

export type DashboardHomeHighPriorityOutfitterBannerSectionFieldsFragment = { __typename?: 'HighPriorityOutfitterBannerSection', id: string, title: string, order: number, banners: Array<{ __typename?: 'Banner', id: string, type: Types.BannerType, content_default: { __typename?: 'BannerContent', title_lines: Array<string>, body?: string | null, color_mode?: Types.ColorMode | null, image?: { __typename?: 'Media', url: string } | null, ctas: Array<{ __typename?: 'CallToAction', url_default: string, url_ios?: string | null, url_android?: string | null, label: string, image?: { __typename?: 'Media', url: string } | null }> }, content_mobile?: { __typename?: 'BannerContent', title_lines: Array<string>, body?: string | null, color_mode?: Types.ColorMode | null, image?: { __typename?: 'Media', url: string } | null, ctas: Array<{ __typename?: 'CallToAction', url_default: string, url_ios?: string | null, url_android?: string | null, label: string, image?: { __typename?: 'Media', url: string } | null }> } | null }> };

export type DashboardHomeBookingsSectionFieldsFragment = { __typename?: 'BookingsSection', id: string, title: string, order: number, bookings: Array<{ __typename?: 'Booking', id: string, status: Types.BookingStatus, dates: Array<number>, check_in_time: number, check_out_time: number, start_date: number, end_date: number, total: number, notes?: string | null, discount?: number | null, is_offsite?: boolean | null, created_at: number, color?: string | null, listing: { __typename?: 'Listing', id: string, type?: Types.ListingType | null, title?: string | null, time_zone?: string | null, color: string }, outfitter: { __typename?: 'Outfitter', id: string, name: string, time_zone?: string | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email: string, avatar_url?: string | null }, client?: { __typename?: 'OutfitterBookingClient', id: string, outfitter_id: string, user: { __typename?: 'OutfitterClientUser', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, avatar_url?: string | null } } | null, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, package_id?: string | null, name: string, quantity: number, category: string }> | null, coupon?: { __typename?: 'Coupon', id: string, custom_code: string } | null, items: Array<{ __typename?: 'QuoteItem', name: string, quantity: number, option_id: string, price: number, rate: number }> }> };

export type DashboardHomeQuickAccessSectionFieldsFragment = { __typename?: 'QuickAccessSection', id: string, title: string, order: number, actions: Array<{ __typename?: 'QuickAccessAction', id: string, label: string, url: string, badge?: Types.FeatureBadgeType | null, feature_key: Types.FeatureIconKey }> };

export type DashboardHomeTipsSectionFieldsFragment = { __typename?: 'TipsSection', id: string, title: string, order: number, tips: Array<{ __typename?: 'Tip', id: string, title: string, message: string, action_url?: string | null, action_label?: string | null }> };

export type DashboardHomeReportingSectionFieldsFragment = { __typename?: 'ReportingSection', id: string, title: string, order: number, url: string, metrics: Array<{ __typename?: 'Metric', id: string, label: string, description: string, value: number, formatted_value: string, metric_key: string, metric_bucket: Types.MetricBucket, date_timestamp: number, created_at: number, updated_at: number, delta: { __typename?: 'MetricDelta', change: string, change_type: Types.MetricChangeType } }> };

export type DashboardHomeFeaturesSectionFieldsFragment = { __typename?: 'FeaturesSection', id: string, title: string, order: number, features: Array<{ __typename?: 'Feature', id: string, title: string, description: string, url: string, badge?: Types.FeatureBadgeType | null, feature_key: Types.FeatureIconKey }> };

export type DashboardHomeAlertsSectionFieldsFragment = { __typename?: 'AlertsSection', id: string, title: string, order: number, alerts: Array<{ __typename?: 'Alert', id: string, title: string, message: string, action_url?: string | null, action_label?: string | null, severity: Types.AlertSeverity }> };

export type DashboardHomeSectionFields_AlertsSection_Fragment = { __typename: 'AlertsSection', id: string, title: string, order: number, alerts: Array<{ __typename?: 'Alert', id: string, title: string, message: string, action_url?: string | null, action_label?: string | null, severity: Types.AlertSeverity }> };

export type DashboardHomeSectionFields_BannerSection_Fragment = { __typename: 'BannerSection', id: string, title: string, order: number, banners: Array<{ __typename?: 'Banner', id: string, type: Types.BannerType, content_default: { __typename?: 'BannerContent', title_lines: Array<string>, body?: string | null, color_mode?: Types.ColorMode | null, image?: { __typename?: 'Media', url: string } | null, ctas: Array<{ __typename?: 'CallToAction', url_default: string, url_ios?: string | null, url_android?: string | null, label: string, image?: { __typename?: 'Media', url: string } | null }> }, content_mobile?: { __typename?: 'BannerContent', title_lines: Array<string>, body?: string | null, color_mode?: Types.ColorMode | null, image?: { __typename?: 'Media', url: string } | null, ctas: Array<{ __typename?: 'CallToAction', url_default: string, url_ios?: string | null, url_android?: string | null, label: string, image?: { __typename?: 'Media', url: string } | null }> } | null }> };

export type DashboardHomeSectionFields_BookingsSection_Fragment = { __typename: 'BookingsSection', id: string, title: string, order: number, bookings: Array<{ __typename?: 'Booking', id: string, status: Types.BookingStatus, dates: Array<number>, check_in_time: number, check_out_time: number, start_date: number, end_date: number, total: number, notes?: string | null, discount?: number | null, is_offsite?: boolean | null, created_at: number, color?: string | null, listing: { __typename?: 'Listing', id: string, type?: Types.ListingType | null, title?: string | null, time_zone?: string | null, color: string }, outfitter: { __typename?: 'Outfitter', id: string, name: string, time_zone?: string | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email: string, avatar_url?: string | null }, client?: { __typename?: 'OutfitterBookingClient', id: string, outfitter_id: string, user: { __typename?: 'OutfitterClientUser', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, avatar_url?: string | null } } | null, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, package_id?: string | null, name: string, quantity: number, category: string }> | null, coupon?: { __typename?: 'Coupon', id: string, custom_code: string } | null, items: Array<{ __typename?: 'QuoteItem', name: string, quantity: number, option_id: string, price: number, rate: number }> }> };

export type DashboardHomeSectionFields_FeaturesSection_Fragment = { __typename: 'FeaturesSection', id: string, title: string, order: number, features: Array<{ __typename?: 'Feature', id: string, title: string, description: string, url: string, badge?: Types.FeatureBadgeType | null, feature_key: Types.FeatureIconKey }> };

export type DashboardHomeSectionFields_HighPriorityOutfitterBannerSection_Fragment = { __typename: 'HighPriorityOutfitterBannerSection', id: string, title: string, order: number, banners: Array<{ __typename?: 'Banner', id: string, type: Types.BannerType, content_default: { __typename?: 'BannerContent', title_lines: Array<string>, body?: string | null, color_mode?: Types.ColorMode | null, image?: { __typename?: 'Media', url: string } | null, ctas: Array<{ __typename?: 'CallToAction', url_default: string, url_ios?: string | null, url_android?: string | null, label: string, image?: { __typename?: 'Media', url: string } | null }> }, content_mobile?: { __typename?: 'BannerContent', title_lines: Array<string>, body?: string | null, color_mode?: Types.ColorMode | null, image?: { __typename?: 'Media', url: string } | null, ctas: Array<{ __typename?: 'CallToAction', url_default: string, url_ios?: string | null, url_android?: string | null, label: string, image?: { __typename?: 'Media', url: string } | null }> } | null }> };

export type DashboardHomeSectionFields_QuickAccessSection_Fragment = { __typename: 'QuickAccessSection', id: string, title: string, order: number, actions: Array<{ __typename?: 'QuickAccessAction', id: string, label: string, url: string, badge?: Types.FeatureBadgeType | null, feature_key: Types.FeatureIconKey }> };

export type DashboardHomeSectionFields_ReportingSection_Fragment = { __typename: 'ReportingSection', id: string, title: string, order: number, url: string, metrics: Array<{ __typename?: 'Metric', id: string, label: string, description: string, value: number, formatted_value: string, metric_key: string, metric_bucket: Types.MetricBucket, date_timestamp: number, created_at: number, updated_at: number, delta: { __typename?: 'MetricDelta', change: string, change_type: Types.MetricChangeType } }> };

export type DashboardHomeSectionFields_TipsSection_Fragment = { __typename: 'TipsSection', id: string, title: string, order: number, tips: Array<{ __typename?: 'Tip', id: string, title: string, message: string, action_url?: string | null, action_label?: string | null }> };

export type DashboardHomeSectionFieldsFragment = DashboardHomeSectionFields_AlertsSection_Fragment | DashboardHomeSectionFields_BannerSection_Fragment | DashboardHomeSectionFields_BookingsSection_Fragment | DashboardHomeSectionFields_FeaturesSection_Fragment | DashboardHomeSectionFields_HighPriorityOutfitterBannerSection_Fragment | DashboardHomeSectionFields_QuickAccessSection_Fragment | DashboardHomeSectionFields_ReportingSection_Fragment | DashboardHomeSectionFields_TipsSection_Fragment;

export type DashboardHomeQueryVariables = Types.Exact<{
  outfitterId: Types.Scalars['ID']['input'];
}>;


export type DashboardHomeQuery = { __typename?: 'Query', dashboardHome: { __typename?: 'DashboardHome', welcome_message: string, sections: Array<{ __typename: 'AlertsSection', id: string, title: string, order: number, alerts: Array<{ __typename?: 'Alert', id: string, title: string, message: string, action_url?: string | null, action_label?: string | null, severity: Types.AlertSeverity }> } | { __typename: 'BannerSection', id: string, title: string, order: number, banners: Array<{ __typename?: 'Banner', id: string, type: Types.BannerType, content_default: { __typename?: 'BannerContent', title_lines: Array<string>, body?: string | null, color_mode?: Types.ColorMode | null, image?: { __typename?: 'Media', url: string } | null, ctas: Array<{ __typename?: 'CallToAction', url_default: string, url_ios?: string | null, url_android?: string | null, label: string, image?: { __typename?: 'Media', url: string } | null }> }, content_mobile?: { __typename?: 'BannerContent', title_lines: Array<string>, body?: string | null, color_mode?: Types.ColorMode | null, image?: { __typename?: 'Media', url: string } | null, ctas: Array<{ __typename?: 'CallToAction', url_default: string, url_ios?: string | null, url_android?: string | null, label: string, image?: { __typename?: 'Media', url: string } | null }> } | null }> } | { __typename: 'BookingsSection', id: string, title: string, order: number, bookings: Array<{ __typename?: 'Booking', id: string, status: Types.BookingStatus, dates: Array<number>, check_in_time: number, check_out_time: number, start_date: number, end_date: number, total: number, notes?: string | null, discount?: number | null, is_offsite?: boolean | null, created_at: number, color?: string | null, listing: { __typename?: 'Listing', id: string, type?: Types.ListingType | null, title?: string | null, time_zone?: string | null, color: string }, outfitter: { __typename?: 'Outfitter', id: string, name: string, time_zone?: string | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email: string, avatar_url?: string | null }, client?: { __typename?: 'OutfitterBookingClient', id: string, outfitter_id: string, user: { __typename?: 'OutfitterClientUser', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, avatar_url?: string | null } } | null, add_ons?: Array<{ __typename?: 'QuoteAddOn', id: string, package_id?: string | null, name: string, quantity: number, category: string }> | null, coupon?: { __typename?: 'Coupon', id: string, custom_code: string } | null, items: Array<{ __typename?: 'QuoteItem', name: string, quantity: number, option_id: string, price: number, rate: number }> }> } | { __typename: 'FeaturesSection', id: string, title: string, order: number, features: Array<{ __typename?: 'Feature', id: string, title: string, description: string, url: string, badge?: Types.FeatureBadgeType | null, feature_key: Types.FeatureIconKey }> } | { __typename: 'HighPriorityOutfitterBannerSection', id: string, title: string, order: number, banners: Array<{ __typename?: 'Banner', id: string, type: Types.BannerType, content_default: { __typename?: 'BannerContent', title_lines: Array<string>, body?: string | null, color_mode?: Types.ColorMode | null, image?: { __typename?: 'Media', url: string } | null, ctas: Array<{ __typename?: 'CallToAction', url_default: string, url_ios?: string | null, url_android?: string | null, label: string, image?: { __typename?: 'Media', url: string } | null }> }, content_mobile?: { __typename?: 'BannerContent', title_lines: Array<string>, body?: string | null, color_mode?: Types.ColorMode | null, image?: { __typename?: 'Media', url: string } | null, ctas: Array<{ __typename?: 'CallToAction', url_default: string, url_ios?: string | null, url_android?: string | null, label: string, image?: { __typename?: 'Media', url: string } | null }> } | null }> } | { __typename: 'QuickAccessSection', id: string, title: string, order: number, actions: Array<{ __typename?: 'QuickAccessAction', id: string, label: string, url: string, badge?: Types.FeatureBadgeType | null, feature_key: Types.FeatureIconKey }> } | { __typename: 'ReportingSection', id: string, title: string, order: number, url: string, metrics: Array<{ __typename?: 'Metric', id: string, label: string, description: string, value: number, formatted_value: string, metric_key: string, metric_bucket: Types.MetricBucket, date_timestamp: number, created_at: number, updated_at: number, delta: { __typename?: 'MetricDelta', change: string, change_type: Types.MetricChangeType } }> } | { __typename: 'TipsSection', id: string, title: string, order: number, tips: Array<{ __typename?: 'Tip', id: string, title: string, message: string, action_url?: string | null, action_label?: string | null }> }> } };

export type DashboardSearchGroupFieldsFragment = { __typename?: 'DashboardSearchGroup', title: string, count: number, view_more_url: string, results: Array<{ __typename?: 'DashboardSearchResult', title: string, subtitle?: string | null, url: string, image_url?: string | null, feature_key: Types.FeatureIconKey, tag?: { __typename?: 'DashboardSearchTag', label: string, color_scheme: Types.DashboardSearchTagColor } | null }> };

export type DashboardSearchQueryVariables = Types.Exact<{
  outfitterId: Types.Scalars['ID']['input'];
  query: Types.Scalars['String']['input'];
}>;


export type DashboardSearchQuery = { __typename?: 'Query', dashboardSearch: { __typename?: 'DashboardSearchResults', query: string, groups: Array<{ __typename?: 'DashboardSearchGroup', title: string, count: number, view_more_url: string, results: Array<{ __typename?: 'DashboardSearchResult', title: string, subtitle?: string | null, url: string, image_url?: string | null, feature_key: Types.FeatureIconKey, tag?: { __typename?: 'DashboardSearchTag', label: string, color_scheme: Types.DashboardSearchTagColor } | null }> }> } };

export const DashboardHomeBannerSectionFieldsFragmentDoc = gql`
    fragment DashboardHomeBannerSectionFields on BannerSection {
  id
  title
  order
  banners {
    ...BannerFields
  }
}
    ${BannerFieldsFragmentDoc}`;
export const DashboardHomeHighPriorityOutfitterBannerSectionFieldsFragmentDoc = gql`
    fragment DashboardHomeHighPriorityOutfitterBannerSectionFields on HighPriorityOutfitterBannerSection {
  id
  title
  order
  banners {
    ...BannerFields
  }
}
    ${BannerFieldsFragmentDoc}`;
export const DashboardHomeBookingsSectionFieldsFragmentDoc = gql`
    fragment DashboardHomeBookingsSectionFields on BookingsSection {
  id
  title
  order
  bookings {
    ...BookingForListFields
  }
}
    ${BookingForListFieldsFragmentDoc}`;
export const DashboardHomeQuickActionFragmentDoc = gql`
    fragment DashboardHomeQuickAction on QuickAccessAction {
  id
  label
  url
  badge
  feature_key
}
    `;
export const DashboardHomeQuickAccessSectionFieldsFragmentDoc = gql`
    fragment DashboardHomeQuickAccessSectionFields on QuickAccessSection {
  id
  title
  order
  actions {
    ...DashboardHomeQuickAction
  }
}
    ${DashboardHomeQuickActionFragmentDoc}`;
export const DashboardHomeTipFragmentDoc = gql`
    fragment DashboardHomeTip on Tip {
  id
  title
  message
  action_url
  action_label
}
    `;
export const DashboardHomeTipsSectionFieldsFragmentDoc = gql`
    fragment DashboardHomeTipsSectionFields on TipsSection {
  id
  title
  order
  tips {
    ...DashboardHomeTip
  }
}
    ${DashboardHomeTipFragmentDoc}`;
export const DashboardHomeReportingSectionFieldsFragmentDoc = gql`
    fragment DashboardHomeReportingSectionFields on ReportingSection {
  id
  title
  order
  metrics {
    ...MetricFields
  }
  url
}
    ${MetricFieldsFragmentDoc}`;
export const DashboardHomeFeatureFragmentDoc = gql`
    fragment DashboardHomeFeature on Feature {
  id
  title
  description
  url
  badge
  feature_key
}
    `;
export const DashboardHomeFeaturesSectionFieldsFragmentDoc = gql`
    fragment DashboardHomeFeaturesSectionFields on FeaturesSection {
  id
  title
  order
  features {
    ...DashboardHomeFeature
  }
}
    ${DashboardHomeFeatureFragmentDoc}`;
export const DashboardHomeAlertFragmentDoc = gql`
    fragment DashboardHomeAlert on Alert {
  id
  title
  message
  action_url
  action_label
  severity
}
    `;
export const DashboardHomeAlertsSectionFieldsFragmentDoc = gql`
    fragment DashboardHomeAlertsSectionFields on AlertsSection {
  id
  title
  order
  alerts {
    ...DashboardHomeAlert
  }
}
    ${DashboardHomeAlertFragmentDoc}`;
export const DashboardHomeSectionFieldsFragmentDoc = gql`
    fragment DashboardHomeSectionFields on DashboardSection {
  __typename
  ... on BannerSection {
    ...DashboardHomeBannerSectionFields
  }
  ... on HighPriorityOutfitterBannerSection {
    ...DashboardHomeHighPriorityOutfitterBannerSectionFields
  }
  ... on BookingsSection {
    ...DashboardHomeBookingsSectionFields
  }
  ... on QuickAccessSection {
    ...DashboardHomeQuickAccessSectionFields
  }
  ... on TipsSection {
    ...DashboardHomeTipsSectionFields
  }
  ... on ReportingSection {
    ...DashboardHomeReportingSectionFields
  }
  ... on FeaturesSection {
    ...DashboardHomeFeaturesSectionFields
  }
  ... on AlertsSection {
    ...DashboardHomeAlertsSectionFields
  }
}
    ${DashboardHomeBannerSectionFieldsFragmentDoc}
${DashboardHomeHighPriorityOutfitterBannerSectionFieldsFragmentDoc}
${DashboardHomeBookingsSectionFieldsFragmentDoc}
${DashboardHomeQuickAccessSectionFieldsFragmentDoc}
${DashboardHomeTipsSectionFieldsFragmentDoc}
${DashboardHomeReportingSectionFieldsFragmentDoc}
${DashboardHomeFeaturesSectionFieldsFragmentDoc}
${DashboardHomeAlertsSectionFieldsFragmentDoc}`;
export const DashboardSearchGroupFieldsFragmentDoc = gql`
    fragment DashboardSearchGroupFields on DashboardSearchGroup {
  title
  count
  view_more_url
  results {
    title
    subtitle
    url
    image_url
    feature_key
    tag {
      label
      color_scheme
    }
  }
}
    `;
export const DashboardHomeDocument = gql`
    query dashboardHome($outfitterId: ID!) {
  dashboardHome(outfitterId: $outfitterId) {
    welcome_message
    sections {
      __typename
      ... on BannerSection {
        id
        title
        order
        banners {
          ...BannerFields
        }
      }
      ... on HighPriorityOutfitterBannerSection {
        id
        title
        order
        banners {
          ...BannerFields
        }
      }
      ... on BookingsSection {
        id
        title
        order
        bookings {
          ...BookingForListFields
        }
      }
      ... on QuickAccessSection {
        id
        title
        order
        actions {
          ...DashboardHomeQuickAction
        }
      }
      ... on TipsSection {
        id
        title
        order
        tips {
          ...DashboardHomeTip
        }
      }
      ... on ReportingSection {
        id
        title
        order
        metrics {
          ...MetricFields
        }
        url
      }
      ... on FeaturesSection {
        id
        title
        order
        features {
          ...DashboardHomeFeature
        }
      }
      ... on AlertsSection {
        id
        title
        order
        alerts {
          ...DashboardHomeAlert
        }
      }
    }
  }
}
    ${BannerFieldsFragmentDoc}
${BookingForListFieldsFragmentDoc}
${DashboardHomeQuickActionFragmentDoc}
${DashboardHomeTipFragmentDoc}
${MetricFieldsFragmentDoc}
${DashboardHomeFeatureFragmentDoc}
${DashboardHomeAlertFragmentDoc}`;

/**
 * __useDashboardHomeQuery__
 *
 * To run a query within a React component, call `useDashboardHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardHomeQuery({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *   },
 * });
 */
export function useDashboardHomeQuery(baseOptions: Apollo.QueryHookOptions<DashboardHomeQuery, DashboardHomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardHomeQuery, DashboardHomeQueryVariables>(DashboardHomeDocument, options);
      }
export function useDashboardHomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardHomeQuery, DashboardHomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardHomeQuery, DashboardHomeQueryVariables>(DashboardHomeDocument, options);
        }
export type DashboardHomeQueryHookResult = ReturnType<typeof useDashboardHomeQuery>;
export type DashboardHomeLazyQueryHookResult = ReturnType<typeof useDashboardHomeLazyQuery>;
export type DashboardHomeQueryResult = Apollo.QueryResult<DashboardHomeQuery, DashboardHomeQueryVariables>;
export const DashboardSearchDocument = gql`
    query dashboardSearch($outfitterId: ID!, $query: String!) {
  dashboardSearch(outfitterId: $outfitterId, query: $query) {
    query
    groups {
      ...DashboardSearchGroupFields
    }
  }
}
    ${DashboardSearchGroupFieldsFragmentDoc}`;

/**
 * __useDashboardSearchQuery__
 *
 * To run a query within a React component, call `useDashboardSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardSearchQuery({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useDashboardSearchQuery(baseOptions: Apollo.QueryHookOptions<DashboardSearchQuery, DashboardSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardSearchQuery, DashboardSearchQueryVariables>(DashboardSearchDocument, options);
      }
export function useDashboardSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardSearchQuery, DashboardSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardSearchQuery, DashboardSearchQueryVariables>(DashboardSearchDocument, options);
        }
export type DashboardSearchQueryHookResult = ReturnType<typeof useDashboardSearchQuery>;
export type DashboardSearchLazyQueryHookResult = ReturnType<typeof useDashboardSearchLazyQuery>;
export type DashboardSearchQueryResult = Apollo.QueryResult<DashboardSearchQuery, DashboardSearchQueryVariables>;